import { FC } from "react";
import classNames from "classnames";
import "./StatusIndicator.css";

type Props = {
  label: string;
  color: string;
  title?: string;
  /** The editor navigation uses only the dot and keeps the status in the tooltip. */
  theme?: "full" | "circle";
};

/** Renders a status whose meaning, label, and color are supplied by the caller. */
export const StatusIndicator: FC<Props> = ({
  label,
  color,
  title,
  theme = "full",
}) => (
  <div
    className={classNames("StatusIndicator", `StatusIndicator--theme-${theme}`)}
    title={title}
  >
    <div className="StatusIndicator__Indicator" style={{ color }} />
    <div className="StatusIndicator__Text">{label}</div>
  </div>
);
